/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OnboardingStatusEnum } from './OnboardingStatusEnum';
import {
    OnboardingStatusEnumFromJSON,
    OnboardingStatusEnumFromJSONTyped,
    OnboardingStatusEnumToJSON,
    OnboardingStatusEnumToJSONTyped,
} from './OnboardingStatusEnum';
import type { Invitation } from './Invitation';
import {
    InvitationFromJSON,
    InvitationFromJSONTyped,
    InvitationToJSON,
    InvitationToJSONTyped,
} from './Invitation';
import type { Membership } from './Membership';
import {
    MembershipFromJSON,
    MembershipFromJSONTyped,
    MembershipToJSON,
    MembershipToJSONTyped,
} from './Membership';
import type { TeamFeatures } from './TeamFeatures';
import {
    TeamFeaturesFromJSON,
    TeamFeaturesFromJSONTyped,
    TeamFeaturesToJSON,
    TeamFeaturesToJSONTyped,
} from './TeamFeatures';
import type { SubscriptionTypeEnum } from './SubscriptionTypeEnum';
import {
    SubscriptionTypeEnumFromJSON,
    SubscriptionTypeEnumFromJSONTyped,
    SubscriptionTypeEnumToJSON,
    SubscriptionTypeEnumToJSONTyped,
} from './SubscriptionTypeEnum';

/**
 * 
 * @export
 * @interface PatchedTeam
 */
export interface PatchedTeam {
    /**
     * 
     * @type {number}
     * @memberof PatchedTeam
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedTeam
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTeam
     */
    slug?: string;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof PatchedTeam
     */
    readonly members?: Array<Membership>;
    /**
     * 
     * @type {Array<Invitation>}
     * @memberof PatchedTeam
     */
    readonly invitations?: Array<Invitation>;
    /**
     * 
     * @type {string}
     * @memberof PatchedTeam
     */
    readonly dashboardUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedTeam
     */
    readonly isAdmin?: boolean;
    /**
     * Current status of team onboarding process
     * 
     * * `not_started` - Not Started
     * * `in_progress` - In Progress
     * * `completed` - Completed
     * * `expired` - Expired
     * @type {OnboardingStatusEnum}
     * @memberof PatchedTeam
     */
    readonly onboardingStatus?: OnboardingStatusEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof PatchedTeam
     */
    readonly subscriptionType?: SubscriptionTypeEnum;
    /**
     * Credits available for monitoring domains for stealer leaks
     * @type {number}
     * @memberof PatchedTeam
     */
    readonly stealerLeaksCredits?: number;
    /**
     * 
     * @type {TeamFeatures}
     * @memberof PatchedTeam
     */
    readonly features?: TeamFeatures;
}



/**
 * Check if a given object implements the PatchedTeam interface.
 */
export function instanceOfPatchedTeam(value: object): value is PatchedTeam {
    return true;
}

export function PatchedTeamFromJSON(json: any): PatchedTeam {
    return PatchedTeamFromJSONTyped(json, false);
}

export function PatchedTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(MembershipFromJSON)),
        'invitations': json['invitations'] == null ? undefined : ((json['invitations'] as Array<any>).map(InvitationFromJSON)),
        'dashboardUrl': json['dashboard_url'] == null ? undefined : json['dashboard_url'],
        'isAdmin': json['is_admin'] == null ? undefined : json['is_admin'],
        'onboardingStatus': json['onboarding_status'] == null ? undefined : OnboardingStatusEnumFromJSON(json['onboarding_status']),
        'subscriptionType': json['subscription_type'] == null ? undefined : SubscriptionTypeEnumFromJSON(json['subscription_type']),
        'stealerLeaksCredits': json['stealer_leaks_credits'] == null ? undefined : json['stealer_leaks_credits'],
        'features': json['features'] == null ? undefined : TeamFeaturesFromJSON(json['features']),
    };
}

  export function PatchedTeamToJSON(json: any): PatchedTeam {
      return PatchedTeamToJSONTyped(json, false);
  }

  export function PatchedTeamToJSONTyped(value?: Omit<PatchedTeam, 'id'|'name'|'members'|'invitations'|'dashboard_url'|'is_admin'|'onboarding_status'|'subscription_type'|'stealer_leaks_credits'|'features'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
    };
}

